module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/how_to_enjoy_photography_case1-19a6467b1ee564a6ea2b03deaa337d0e.jpg";